import React from "react";

import cn from "classnames";
import { useNavigate } from "react-router-dom";

import { Button } from "components/Button";
import { VIRTUAL_ASSETS_PATH } from "constants/pages";
import { ProcessStatus } from "types/process";

import { Alert } from "./Alert";

import styles from "./Alert.module.scss";

type Props = {
  status: ProcessStatus;
};

export const RemediationAlert = ({ status }: Props) => {
  const navigate = useNavigate();

  return (
    <Alert
      className={cn(styles.alert, styles.remediation)}
      type={"warning"}
      message={"Compliance update required"}
      description={
        <p className={styles.remediationAlertDescriptionText}>
          To continue using your account, we need to confirm a few details about your employment. This is part of a
          recent compliance update. Please review and update your employment information to regain your previous Tier
          level.
        </p>
      }
      action={
        <div className={styles.remediationAction}>
          <Button className={styles.actionBtn} onClick={() => navigate(VIRTUAL_ASSETS_PATH)}>
            Update now
          </Button>
        </div>
      }
      closable={false}
    />
  );
};
